import React from 'react';
import { connect } from 'react-redux';
import LoginForm from './LoginForm';
import { browserHistory } from 'react-router';
import { bindActionCreators } from 'redux';
import * as loginActions from '../../actions/loginActionCreators';
import ForgotPasswordModal from './ForgotPasswordModal';
import { Row, Col } from 'react-bootstrap';

class Login extends React.Component {
  constructor(props, context) {
    super(props, context);

    const redirectRoute = this.props.location.query.next || '/administer/wharton-test';

    this.state = {
      email: '',
      password: '',
      redirectTo: redirectRoute,
      error: null,
      inProgress: false,
      showForgotPassModal: false,
      initialEmail: ''
    };

    this.login = this.login.bind(this);
    this.openForgotPassModal = this.openForgotPassModal.bind(this);
    this.closeForgotPassModal = this.closeForgotPassModal.bind(this);
  }

  componentWillMount() {
    let runName = localStorage.getItem('run');
    let auth = localStorage.getItem('auth');
    if (auth && runName) {
      browserHistory.push('/administer/' + runName + '/assignment');
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.form != this.props.form) {
      if (nextProps.form.login && nextProps.form.login.values && nextProps.form.login.values.email) {
        this.setState({ initialEmail: nextProps.form.login.values.email });
      }
    }
  }

  login = values => {
    this.setState({ inProgress: true });
    let email = values.email.substring(0, 40).toLowerCase();

    let auth = {
      email,
      password: values.loginPassword
    };
    let runName = this.props.runName;
    this.props.actions.loginUser(runName, auth).then(
      () => {
        localStorage.setItem('email', values.email);
        browserHistory.push('/administer/' + runName + '/assignment');
      },
      () => {
        this.setState({ inProgress: false });
        this.setState({ error: 'Check your credentials please' });
      }
    );
  };
  openForgotPassModal() {
    this.setState({ showForgotPassModal: true });
  }
  closeForgotPassModal() {
    this.setState({ showForgotPassModal: false });
  }

  render() {
    return (
      <div>
        <Row>
          <Col md={12}>
            <div className="page-subtitle">Log In</div>
            <div className="login-form relative">
              <LoginForm inProgress={this.state.inProgress} onSubmit={this.login} />
              <div
                href=""
                className="forgot-password-label"
                onClick={() => {
                  this.openForgotPassModal();
                }}
              >
                Forgot Password
              </div>
              {this.state.error && <span className="text-danger absolute">{this.state.error}</span>}
            </div>
          </Col>
        </Row>

        <ForgotPasswordModal
          closeModal={this.closeForgotPassModal}
          showModal={this.state.showForgotPassModal}
          initialValue={this.state.initialEmail}
        />
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  let runName = ownProps.params.runName;

  localStorage.setItem('run', runName);
  sessionStorage.setItem('run', runName);
  return {
    runName: runName,
    isAuthenticated: state.login.isAuthenticated,
    form: state.form
  };
}

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators(loginActions, dispatch) };
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/components/login/LoginPage.js